import { useLogin } from "@/context/useLoginProps";
import { CheckboxOptionType } from "@/types";
import { SingleSelectDropdown } from "@monsterindia/global-ui-components";
import React from "react";

import { loginLeftFooterProps } from "../../types";

const LoginLeftFooter: React.FC<loginLeftFooterProps> = ({
  selectedCountry,
  countryList,
}) => {
  const { isMobile } = useLogin();
  return (
    <div className="flex items-start gap-4 pb-[42px] pt-[19px]">
      {!isMobile && (
        <div className="w-[178px]">
          <SingleSelectDropdown
            id={selectedCountry?.text}
            width="!l1-w-full"
            className="px-3 py-1"
            isSearchable={false}
            disabled={false}
            options={countryList}
            selectedValue={selectedCountry}
            handleDropdownSelect={(value: CheckboxOptionType) => {
              window.open(value.value, "_blank");
            }}
          />
        </div>
      )}
      <div className="flex h-8 items-center justify-center text-center">
        <span className="text-xs font-normal text-[#1D1934]">
          © {new Date().getFullYear()} foundit | All rights Reserved
        </span>
      </div>
    </div>
  );
};

export default LoginLeftFooter;
